<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">
          Referente ao Processo: {{ excerto.cdProcesso || "" }}/{{
            excerto.cdAno || ""
          }}
        </h4>
      </v-alert>
      <v-form :disabled="!userHasPermission()" v-model="valid" lazy-validation ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                disabled
                class="font-weight-black"
                type="number"
                label="Prejulgado"
                v-model="excerto.excertoId"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-if="excerto.dataInclusao"
                disabled
                class="font-weight-black"
                label="Inclusão"
                type="date"
                mask="dd/MM/yyyy"
                v-model="excerto.dataInclusao"
              ></v-text-field>
              <v-text-field
                v-else
                disabled
                class="font-weight-black"
                label="Inclusão"
                value="Não Informado"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                disabled
                class="font-weight-black"
                type="number"
                label="Exercício Financeiro"
                v-model="excerto.processo.exercicio"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                disabled
                class="font-weight-black"
                label="Natureza"
                v-model="excerto.processo.natureza"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="1">
              <v-text-field
                type="number"
                label="Processo"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="excerto.cdProcesso"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="1">
              <v-text-field
                type="number"
                label="Ano"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="excerto.cdAno"
                @blur="buscarProcesso"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="5" style="margin-top: 1.1%">
              <v-select
                solo
                dense
                v-model="tema"
                :items="listaTema"
                item-text="nome"
                item-value="temaId"
                label="Tema"
                :rules="[
                  (v) => v.temaId != null || 'Este campo é obrigatório!',
                ]"
                return-object
              ></v-select>
            </v-col>

            <v-col cols="12" md="5" style="margin-top: 1.1%">
              <v-select
                solo
                dense
                v-model="excerto.subtema"
                :items="tema.subTemas"
                item-text="nome"
                item-value="subtemaId"
                label="Subtema"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                disabled
                class="font-weight-black"
                label="Responsável"
                v-model="excerto.processo.responsavel"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                disabled
                class="font-weight-black"
                label="Relator"
                v-model="excerto.processo.relator"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="5">
              <v-text-field
                disabled
                class="font-weight-black"
                label="Origem"
                v-model="excerto.processo.unidade"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="texto"
                label="Excerto"
                v-model="excerto.texto"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="observacao"
                label="Observação"
                v-model="excerto.observacao"
              ></v-textarea>
            </v-col>
          </v-row>

          <template>
            <v-data-table
              :headers="headers"
              :items="deliberacoes"
              :items-per-page="5"
              class="elevation-1"
              no-results-text="Não existem deliberações."
              no-data-text="Não existem deliberações."
            >
              <template v-slot:item.dataSessaoFormatada="{ item }">
                <span>{{
                  new Date(
                    $moment(item.dataSessao).format()
                  ).toLocaleDateString()
                }}</span>
              </template>
              <template v-slot:item.dataCirculacaoFormatada="{ item }">
                <span>{{
                  new Date(
                    $moment(item.dataCirculacao).format()
                  ).toLocaleDateString()
                }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                      @click="abrirDecisao(item)"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template>
                  <span>Decisão</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </template>

          <v-row>
            <v-col>
              <v-btn
                color="primary"
                small
                depressed
                @click="salvar"
                :disabled="!userHasPermission()"
                >Salvar</v-btn
              >
              <span></span>
              <v-btn
                style="margin-left: 2%"
                color="primary"
                small
                depressed
                to="/prejulgados"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </app-layout>
</template>

<script>
import excertoService from "@/service/ExcertoService";
export default {
  data() {
    return {
      valid: false,
      id: this.$route.params.id,

      excerto: {
        dataInclusao: this.$moment().format("YYYY-MM-DD"),
        cdProcesso: "",
        cdAno: "",
        texto: "",
        processo: {
          relator: "",
          responsavel: "",
          exercicio: "",
          natureza: "",
        },
      },
      tema: {},
      listaTema: [],
      deliberacoes: [],

      headers: [
        {
          align: "start",
          sortable: false,
        },
        { text: "Data da Sessão", value: "dataSessaoFormatada" },
        { text: "Publicação", value: "dataCirculacaoFormatada" },
        { text: "Tipo da Decisão", value: "tipoDeliberacao" },
        { text: "Abrir Decisão", value: "actions", align: "center" },
      ],
    };
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    salvar() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        excertoService
          .salvar(this.excerto)
          .then((result) => {
            (this.excerto = result), alert("Salvo com sucesso!");
            this.$router.push("/prejulgados");
          })
          .catch((err) => console.error(err.message));
      } else {
        alert("Informe os campos Obrigatórios!");
      }
    },

    buscarProcesso() {
      if (this.excerto.cdAno && this.excerto.cdProcesso) {
        excertoService
          .buscarProcesso(this.excerto.cdProcesso, this.excerto.cdAno)
          .then((result) => {
            (this.excerto.processo = result),
              excertoService
                .buscarDeliberacoes(this.excerto.processo.processoId)
                .then((result) => (this.deliberacoes = result));
            if (!result) alert("Processo não encontrado.");
          });
      } else {
        alert("Informe Processo e Ano corretamente.");
      }
    },

    abrirDecisao(item) {
      if (item.textoDecisao != null && item.textoDecisao != "") {
        let rota = this.$router.resolve("/decisao/" + item.deliberacaoId);
        window.open(rota.href, "_blank");
      } else alert("Este documento não possui visualização HTML!");
    },
  },
  created() {
    excertoService.findAllTemas().then((result) => (this.listaTema = result));

    if (this.id != 0) {
      excertoService
        .buscarExcerto(this.id)
        .then((result) => {
          (this.excerto = result),
            excertoService
              .buscarTema(this.excerto.subtema.temaDTO.temaId)
              .then((result) => (this.tema = result));
          excertoService
            .buscarDeliberacoes(this.excerto.processo.processoId)
            .then((result) => (this.deliberacoes = result));
        })
        .catch((err) => {
          console.error(err.message), this.$router.push("/notfound");
        });
    }
  },
};
</script>

<style>
</style>